/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMessageSeverity } from './UserMessageSeverity';
import {
    UserMessageSeverityFromJSON,
    UserMessageSeverityFromJSONTyped,
    UserMessageSeverityToJSON,
    UserMessageSeverityToJSONTyped,
} from './UserMessageSeverity';
import type { ActiveDirectoryAction } from './ActiveDirectoryAction';
import {
    ActiveDirectoryActionFromJSON,
    ActiveDirectoryActionFromJSONTyped,
    ActiveDirectoryActionToJSON,
    ActiveDirectoryActionToJSONTyped,
} from './ActiveDirectoryAction';
import type { RegisterReasonCodes } from './RegisterReasonCodes';
import {
    RegisterReasonCodesFromJSON,
    RegisterReasonCodesFromJSONTyped,
    RegisterReasonCodesToJSON,
    RegisterReasonCodesToJSONTyped,
} from './RegisterReasonCodes';

/**
 * 
 * @export
 * @interface RegisterResponseV2
 */
export interface RegisterResponseV2 {
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    version: string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof RegisterResponseV2
     */
    action: ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    userMessage?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof RegisterResponseV2
     */
    messageSeverity?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponseV2
     */
    status?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponseV2
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    mpk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    reasonPhrase: string;
    /**
     * 
     * @type {RegisterReasonCodes}
     * @memberof RegisterResponseV2
     */
    reasonCode: RegisterReasonCodes;
}



/**
 * Check if a given object implements the RegisterResponseV2 interface.
 */
export function instanceOfRegisterResponseV2(value: object): value is RegisterResponseV2 {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('reasonPhrase' in value) || value['reasonPhrase'] === undefined) return false;
    if (!('reasonCode' in value) || value['reasonCode'] === undefined) return false;
    return true;
}

export function RegisterResponseV2FromJSON(json: any): RegisterResponseV2 {
    return RegisterResponseV2FromJSONTyped(json, false);
}

export function RegisterResponseV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterResponseV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'action': ActiveDirectoryActionFromJSON(json['action']),
        'userMessage': json['userMessage'] == null ? undefined : json['userMessage'],
        'messageSeverity': json['messageSeverity'] == null ? undefined : UserMessageSeverityFromJSON(json['messageSeverity']),
        'status': json['status'] == null ? undefined : json['status'],
        'statusCode': json['statusCode'],
        'mpk': json['mpk'] == null ? undefined : json['mpk'],
        'reasonPhrase': json['reason_phrase'],
        'reasonCode': RegisterReasonCodesFromJSON(json['reason_code']),
    };
}

export function RegisterResponseV2ToJSON(json: any): RegisterResponseV2 {
    return RegisterResponseV2ToJSONTyped(json, false);
}

export function RegisterResponseV2ToJSONTyped(value?: RegisterResponseV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'action': ActiveDirectoryActionToJSON(value['action']),
        'userMessage': value['userMessage'],
        'messageSeverity': UserMessageSeverityToJSON(value['messageSeverity']),
        'status': value['status'],
        'statusCode': value['statusCode'],
        'mpk': value['mpk'],
        'reason_phrase': value['reasonPhrase'],
        'reason_code': RegisterReasonCodesToJSON(value['reasonCode']),
    };
}

